<div class="training-videos-container">
  <!--     CrewApp    -->
  <mat-accordion class="training-videos-list" [multi]="true">
    <mat-expansion-panel class="leg-panel" [expanded]="false">
      <mat-expansion-panel-header>
        <mat-panel-title class="text-uppercase panel-title">
          <span>CrewApp</span>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <ng-template matExpansionPanelContent>
        <div class="row">
          <div class="col-xl-3 col-lg-6">
            <div class="video-container">
              <iframe class="video-item" src="https://www.youtube.com/embed/Dzi_Vs6a6NY?si=Ue1Z0tY4QcMJ37ka"
                      loading="lazy"
                      title="YouTube video player" frameborder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                      referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
            </div>
            <div class="text-center video-title">Preflight Overview</div>
          </div>

          <div class="col-xl-3 col-lg-6">
            <div class="video-container">
              <iframe class="video-item" src="https://www.youtube.com/embed/LaRZ2gS0lKY?si=QzYdl_hLnO9PAzRg"
                      loading="lazy"
                      title="YouTube video player" frameborder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                      referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
            </div>
            <div class="text-center video-title">Postflight Overview</div>
          </div>
        </div>
      </ng-template>
    </mat-expansion-panel>
  </mat-accordion>
  <!--     PostFlight    -->
  <mat-accordion class="training-videos-list" [multi]="true">
    <mat-expansion-panel class="leg-panel" [expanded]="false">
      <mat-expansion-panel-header>
        <mat-panel-title class="text-uppercase panel-title">
          <span>PostFlight</span>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <ng-template matExpansionPanelContent>
        <div class="row">
          <div class="col-xl-3 col-lg-6">
            <div class="video-container">
              <iframe class="video-item" src="https://www.youtube.com/embed/RZzYETW_mpI?si=Je1HFI-RGzfBVgsz"
                      loading="lazy"
                      title="YouTube video player" frameborder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                      referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
            </div>
            <div class="text-center video-title">Enter squawks & discrepancies</div>
          </div>

          <div class="col-xl-3 col-lg-6">
            <div class="video-container">
              <iframe class="video-item" src="https://www.youtube.com/embed/h46M77s8Ph8?si=YXD9LRjMRl-vCaPg"
                      loading="lazy"
                      title="YouTube video player" frameborder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                      referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
            </div>
            <div class="text-center video-title">Merging legs</div>
          </div>

          <div class="col-xl-3 col-lg-6">
            <div class="video-container">
              <iframe class="video-item" src="https://www.youtube.com/embed/9MXh6fnhvMg?si=x9t8svsRysfuAtuy"
                      loading="lazy"
                      title="YouTube video player" frameborder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                      referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
            </div>
            <div class="text-center video-title">Logging a flight using a hobbs meter</div>
          </div>

          <div class="col-xl-3 col-lg-6">
            <div class="video-container">
              <iframe class="video-item" src="https://www.youtube.com/embed/xQp_dXKgql4?si=jdPCytQTn2EOx9xp"
                      loading="lazy"
                      title="YouTube video player" frameborder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                      referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
            </div>
            <div class="text-center video-title">Overview of the trip manager</div>
          </div>

          <div class="col-xl-3 col-lg-6">
            <div class="video-container">
              <iframe class="video-item" src="https://www.youtube.com/embed/x8Jvo7aNAl8?si=URTWUh9LtQyrADQ_"
                      loading="lazy"
                      title="YouTube video player" frameborder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                      referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
            </div>
            <div class="text-center video-title">Generate & download reports</div>
          </div>

          <div class="col-xl-3 col-lg-6">
            <div class="video-container">
              <iframe class="video-item" src="https://www.youtube.com/embed/V6xvuM2dG74?si=njZ6yZJRhUnIYxy3"
                      loading="lazy"
                      title="YouTube video player" frameborder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                      referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
            </div>
            <div class="text-center video-title">Log a completed flight (basics)</div>
          </div>

          <div class="col-xl-3 col-lg-6">
            <div class="video-container">
              <iframe class="video-item" src="https://www.youtube.com/embed/G4OYqCbHtEc?si=6ir4ZINONyqZIadp"
                      loading="lazy"
                      title="YouTube video player" frameborder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                      referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
            </div>
            <div class="text-center video-title">Recording trip</div>
          </div>

          <div class="col-xl-3 col-lg-6">
            <div class="video-container">
              <iframe class="video-item" src="https://www.youtube.com/embed/2YhXAIBYUWc?si=naACJnuyZJlpUeMc"
                      loading="lazy"
                      title="YouTube video player" frameborder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                      referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
            </div>
            <div class="text-center video-title">Maintenance Integrations</div>
          </div>
        </div>
      </ng-template>
    </mat-expansion-panel>
  </mat-accordion>
  <!--     PreFlight    -->
  <mat-accordion class="training-videos-list" [multi]="true">
    <mat-expansion-panel class="leg-panel" [expanded]="false">
      <mat-expansion-panel-header>
        <mat-panel-title class="text-uppercase panel-title">
          <span>PreFlight</span>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <ng-template matExpansionPanelContent>
        <div class="row">
          <div class="col-xl-3 col-lg-6">
            <div class="video-container">
              <iframe class="video-item" src="https://www.youtube.com/embed/DdYsI0AWX10?si=GCY4lNbAuBubEKXD"
                      loading="lazy"
                      title="YouTube video player" frameborder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                      referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
            </div>
            <div class="text-center video-title">Using the PreFlight Polaris Aero integration</div>
          </div>

          <div class="col-xl-3 col-lg-6">
            <div class="video-container">
              <iframe class="video-item" src="https://www.youtube.com/embed/VOyYSZdN5rY?si=xSy_wrsUM0s1tqDR"
                      loading="lazy"
                      title="YouTube video player" frameborder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                      referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
            </div>
            <div class="text-center video-title">Using the PreFlight FlightBridge integration</div>
          </div>

          <div class="col-xl-3 col-lg-6">
            <div class="video-container">
              <iframe class="video-item" src="https://www.youtube.com/embed/RzK4H0dM4UI?si=_wh2X4mxGHzF0fYn"
                      loading="lazy"
                      title="YouTube video player" frameborder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                      referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
            </div>
            <div class="text-center video-title">Trip conflict overview</div>
          </div>

          <div class="col-xl-3 col-lg-6">
            <div class="video-container">
              <iframe class="video-item" src="https://www.youtube.com/embed/coZnmkfkCVE?si=ivr4Vx8W_7G6m37N"
                      loading="lazy"
                      title="YouTube video player" frameborder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                      referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
            </div>
            <div class="text-center video-title">Submitting an eapis report update</div>
          </div>

          <div class="col-xl-3 col-lg-6">
            <div class="video-container">
              <iframe class="video-item" src="https://www.youtube.com/embed/wlRQQIM5mKc?si=63LSXP_SUNifyBvy"
                      loading="lazy"
                      title="YouTube video player" frameborder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                      referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
            </div>
            <div class="text-center video-title">Sending & acknowledging trip notifications</div>
          </div>

          <div class="col-xl-3 col-lg-6">
            <div class="video-container">
              <iframe class="video-item" src="https://www.youtube.com/embed/35nR-xy0pqU?si=M3v_h9HN7oiEcwNl"
                      loading="lazy"
                      title="YouTube video player" frameborder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                      referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
            </div>
            <div class="text-center video-title">Auto updating preflight calendar appointments</div>
          </div>
        </div>
      </ng-template>
    </mat-expansion-panel>
  </mat-accordion>
  <!--     Profiles    -->
  <mat-accordion class="training-videos-list" [multi]="true">
    <mat-expansion-panel class="leg-panel" [expanded]="false">
      <mat-expansion-panel-header>
        <mat-panel-title class="text-uppercase panel-title">
          <span>Profiles</span>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <ng-template matExpansionPanelContent>
        <div class="row">
          <div class="col-xl-3 col-lg-6">
            <div class="video-container">
              <iframe class="video-item" src="https://www.youtube.com/embed/Xv_vppeVO14?si=IB8dKzQKvLSfwfVY"
                      loading="lazy"
                      title="YouTube video player" frameborder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                      referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
            </div>
            <div class="text-center video-title">Uploading documents</div>
          </div>

          <div class="col-xl-3 col-lg-6">
            <div class="video-container">
              <iframe class="video-item" src="https://www.youtube.com/embed/1bU0lKFcDQU?si=5Tm6U1v6SVAuOthj"
                      loading="lazy"
                      title="YouTube video player" frameborder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                      referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
            </div>
            <div class="text-center video-title">Uploading contract fuel prices</div>
          </div>

          <div class="col-xl-3 col-lg-6">
            <div class="video-container">
              <iframe class="video-item" src="https://www.youtube.com/embed/OQxXTJDPHfM?si=FplfCfE9QSKH5WqU"
                      loading="lazy"
                      title="YouTube video player" frameborder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                      referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
            </div>
            <div class="text-center video-title">Overview of the profile sections</div>
          </div>

          <div class="col-xl-3 col-lg-6">
            <div class="video-container">
              <iframe class="video-item" src="https://www.youtube.com/embed/kSwRXDDsqPw?si=y6LA1NiOjuCFG2BH"
                      loading="lazy"
                      title="YouTube video player" frameborder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                      referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
            </div>
            <div class="text-center video-title">Overview of the people profile section</div>
          </div>

          <div class="col-xl-3 col-lg-6">
            <div class="video-container">
              <iframe class="video-item" src="https://www.youtube.com/embed/1TZeuR6Fv8w?si=Qkr5jdny_9CKpdd2"
                      loading="lazy"
                      title="YouTube video player" frameborder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                      referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
            </div>
            <div class="text-center video-title">Overview of the fleet overview & trip manager sections</div>
          </div>

          <div class="col-xl-3 col-lg-6">
            <div class="video-container">
              <iframe class="video-item" src="https://www.youtube.com/embed/ayrzWOkhIG0?si=OnLwzWWizVTH-tjE"
                      loading="lazy"
                      title="YouTube video player" frameborder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                      referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
            </div>
            <div class="text-center video-title">Overview of the company profile section</div>
          </div>

          <div class="col-xl-3 col-lg-6">
            <div class="video-container">
              <iframe class="video-item" src="https://www.youtube.com/embed/smbW8IJIAnI?si=yLemr151wNPbs23X"
                      loading="lazy"
                      title="YouTube video player" frameborder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                      referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
            </div>
            <div class="text-center video-title">Overview of the aircraft profile section</div>
          </div>

          <div class="col-xl-3 col-lg-6">
            <div class="video-container">
              <iframe class="video-item" src="https://www.youtube.com/embed/A8F8AGOWbEo?si=64TUssh3LiTgGWJ-"
                      loading="lazy"
                      title="YouTube video player" frameborder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                      referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
            </div>
            <div class="text-center video-title">Managing users</div>
          </div>

          <div class="col-xl-3 col-lg-6">
            <div class="video-container">
              <iframe class="video-item" src="https://www.youtube.com/embed/6bJs_xAGAP4?si=fMi_nnisQJk12J1m"
                      loading="lazy"
                      title="YouTube video player" frameborder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                      referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
            </div>
            <div class="text-center video-title">Managing user roles</div>
          </div>

          <div class="col-xl-3 col-lg-6">
            <div class="video-container">
              <iframe class="video-item" src="https://www.youtube.com/embed/1waFpxJQykE?si=TTJLcYbzKXm0FVKS"
                      loading="lazy"
                      title="YouTube video player" frameborder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                      referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
            </div>
            <div class="text-center video-title">Editing default taxi times</div>
          </div>

          <div class="col-xl-3 col-lg-6">
            <div class="video-container">
              <iframe class="video-item" src="https://www.youtube.com/embed/37STSb7-7V0?si=AY-q-dgj9F2rYDRr"
                      loading="lazy"
                      title="YouTube video player" frameborder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                      referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
            </div>
            <div class="text-center video-title">Editing airport specific taxi times</div>
          </div>

          <div class="col-xl-3 col-lg-6">
            <div class="video-container">
              <iframe class="video-item" src="https://www.youtube.com/embed/z9YO-pervws?si=5egC96DkWnLCNa0D"
                      loading="lazy"
                      title="YouTube video player" frameborder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                      referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
            </div>
            <div class="text-center video-title">Editing airport data</div>
          </div>

          <div class="col-xl-3 col-lg-6">
            <div class="video-container">
              <iframe class="video-item" src="https://www.youtube.com/embed/f8zyVFZBL_U?si=7gmH5Hhp3qdJ02vU"
                      loading="lazy"
                      title="YouTube video player" frameborder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                      referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
            </div>
            <div class="text-center video-title">Editing a passenger profile</div>
          </div>

          <div class="col-xl-3 col-lg-6">
            <div class="video-container">
              <iframe class="video-item" src="https://www.youtube.com/embed/lD7JyVBHWLI?si=LbmQtOSIl_6BCSIH"
                      loading="lazy"
                      title="YouTube video player" frameborder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                      referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
            </div>
            <div class="text-center video-title">Editing a crew member profile</div>
          </div>

          <div class="col-xl-3 col-lg-6">
            <div class="video-container">
              <iframe class="video-item" src="https://www.youtube.com/embed/QNholnkkBBI?si=lvnUGvR7pemCzXGQ"
                      loading="lazy"
                      title="YouTube video player" frameborder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                      referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
            </div>
            <div class="text-center video-title">Customize your aircraft display order</div>
          </div>

          <div class="col-xl-3 col-lg-6">
            <div class="video-container">
              <iframe class="video-item" src="https://www.youtube.com/embed/6TaAu1e_YyE?si=y9y88uHwMeZInDw4"
                      loading="lazy"
                      title="YouTube video player" frameborder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                      referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
            </div>
            <div class="text-center video-title">Creating a new passenger</div>
          </div>

          <div class="col-xl-3 col-lg-6">
            <div class="video-container">
              <iframe class="video-item" src="https://www.youtube.com/embed/Gkry3wcjuuQ?si=bD5QQy1YpbG53cO9"
                      loading="lazy"
                      title="YouTube video player" frameborder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                      referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
            </div>
            <div class="text-center video-title">Creating a new crew member</div>
          </div>

          <div class="col-xl-3 col-lg-6">
            <div class="video-container">
              <iframe class="video-item" src="https://www.youtube.com/embed/UT-rUvxHPRw?si=c3i0C5V47nI3MXik"
                      loading="lazy"
                      title="YouTube video player" frameborder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                      referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
            </div>
            <div class="text-center video-title">Creating a custom service provider</div>
          </div>

          <div class="col-xl-3 col-lg-6">
            <div class="video-container">
              <iframe class="video-item" src="https://www.youtube.com/embed/Gu9VubCiEk8?si=HGyD8yHeT3HXe63_"
                      loading="lazy"
                      title="YouTube video player" frameborder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                      referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
            </div>
            <div class="text-center video-title">Creating a custom fbo</div>
          </div>

          <div class="col-xl-3 col-lg-6">
            <div class="video-container">
              <iframe class="video-item" src="https://www.youtube.com/embed/syqCasxWhpk?si=c0lvK-j6ojva6FpM"
                      loading="lazy"
                      title="YouTube video player" frameborder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                      referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
            </div>
            <div class="text-center video-title">Creating a custom airport profile</div>
          </div>

          <div class="col-xl-3 col-lg-6">
            <div class="video-container">
              <iframe class="video-item" src="https://www.youtube.com/embed/1AWDlYMyN_E?si=7kk2UH7lXW8ZjdSI"
                      loading="lazy"
                      title="YouTube video player" frameborder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                      referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
            </div>
            <div class="text-center video-title">Airport profile overview</div>
          </div>
        </div>
      </ng-template>
    </mat-expansion-panel>
  </mat-accordion>
</div>
